import {
  deleteAdminV1OrgMembersId,
  deleteAdminV1OrgRolesId,
  getAdminV1OrgMembers,
  getAdminV1OrgMembersIdEffectivePermissions,
  getAdminV1OrgRoles,
  patchAdminV1OrgMembersId,
  patchAdminV1OrgRolesId,
  postAdminV1OrgMembersIdResendInvitation,
  postAdminV1OrgMembersInvitations,
  postAdminV1OrgRoles,
  type CreateRoleRequest,
  type Member,
  type MemberEffectivePermissions,
  type PatchAdminV1OrgMembersIdBody,
  type PostAdminV1OrgMembersInvitationsBody,
  type Role,
  type UpdateRoleRequest,
} from '@nucleus-commerce/api-client/admin';

/** Organisation staff and roles; both are bounded `{ items }` dictionaries, no cursor. */
export const teamApi = {
  listMembers: (): Promise<Member[]> => getAdminV1OrgMembers().then((r) => r.items),
  listRoles: (): Promise<Role[]> => getAdminV1OrgRoles().then((r) => r.items),
  invite: (body: PostAdminV1OrgMembersInvitationsBody): Promise<Member> =>
    postAdminV1OrgMembersInvitations(body),
  resendInvitation: (id: string): Promise<Member> =>
    postAdminV1OrgMembersIdResendInvitation({ id }),
  update: (id: string, body: PatchAdminV1OrgMembersIdBody): Promise<Member> =>
    patchAdminV1OrgMembersId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgMembersId({ id }),
  /** Per store, the role that applies and where each permission comes from. */
  effectivePermissions: (id: string): Promise<MemberEffectivePermissions> =>
    getAdminV1OrgMembersIdEffectivePermissions({ id }),
  /** System roles are read-only (409); nobody grants a permission they lack (403). */
  createRole: (body: CreateRoleRequest): Promise<Role> => postAdminV1OrgRoles(body),
  updateRole: (id: string, body: UpdateRoleRequest): Promise<Role> =>
    patchAdminV1OrgRolesId({ id }, body),
  /** 409 RESOURCE_IN_USE while members hold the role (`meta.members`). */
  removeRole: (id: string): Promise<void> => deleteAdminV1OrgRolesId({ id }),
};
